import { cn } from '@plato/ui/util/classes';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import type { ForwardedRef, LabelHTMLAttributes } from 'react';
import { forwardRef } from 'react';

// TODO: refactor this to use a common component when all the styles are unified

const styleLabel = cva(['text-neutral-700 text-sm leading-none hyphens-auto block'], {
    variants: {
        variant: {
            default: 'font-medium',
            thin: null,
        },
        required: {
            true: ["after:content-['*'] after:text-red-500"],
            false: null,
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export type CrmFieldLabelProps = LabelHTMLAttributes<HTMLLabelElement> & VariantProps<typeof styleLabel>;

export const CrmFieldLabel = forwardRef(
    (
        { className, htmlFor, required, variant, ...props }: CrmFieldLabelProps,
        forwardedRef: ForwardedRef<HTMLLabelElement>,
    ) => {
        return (
            <label
                ref={forwardedRef}
                className={cn(styleLabel({ required, variant }), className)}
                htmlFor={htmlFor}
                {...props}
            />
        );
    },
);

CrmFieldLabel.displayName = 'CrmFieldLabel';
